import api from "./api";

/**
 * Busca planos paginados com suporte a busca.
 * @param {number} pageNumber - O número da página.
 * @param {number} pageSize - O tamanho da página.
 * @param {string} search - O termo de busca (opcional).
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function fetchPlansPaged(pageNumber, pageSize, search = "") {
  return api.get("/plans/paged", {
    params: {
      pageNumber,
      pageSize,
      search,
    },
  });
}

/**
 * Busca todos os planos (ativos e inativos).
 * Endpoint para administradores.
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function fetchPlans() {
  return api.get("/plans");
}

/**
 * Busca apenas os planos ativos (para telas públicas).
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function fetchActivePlans() {
  return api.get("/plans/active");
}

/**
 * Busca um plano específico pelo seu ID.
 * @param {number} id - O ID do plano.
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function getPlanById(id) {
  return api.get(`/plans/${id}`);
}

/**
 * Cria um novo plano.
 * @param {object} data - Os dados do plano a ser criado.
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function createPlan(data) {
  return api.post("/plans", data);
}

/**
 * Atualiza um plano existente.
 * @param {number} id - O ID do plano a ser atualizado.
 * @param {object} data - Os dados do plano a serem atualizados.
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function updatePlan(id, data) {
  return api.put(`/plans/${id}`, data);
}

/**
 * Exclui um plano pelo seu ID.
 * @param {number} id - O ID do plano a ser excluído.
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function deletePlan(id) {
  return api.delete(`/plans/${id}`);
}

/**
 * Exclui múltiplos planos em lote.
 * @param {number[]} ids - Um array de IDs de planos a serem excluídos.
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function deletePlansBatch(ids) {
  return api.delete("/plans", { data: ids });
}

/**
 * Alterna o valor do campo 'can_export' de um plano.
 * @param {number} id - O ID do plano.
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function toggleCanExport(id) {
  return api.patch(`/plans/${id}/toggle-export`);
}

/**
 * Alterna o valor do campo 'has_dashboard' de um plano.
 * @param {number} id - O ID do plano.
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function toggleHasDashboard(id) {
  return api.patch(`/plans/${id}/toggle-dashboard`);
}

// ✅ NOVO: alterna o valor do campo 'is_active' de um plano
export function toggleIsActive(id) {
  return api.patch(`/plans/${id}/toggle-active`);
}

// ✅ NOVO (IsPublic): alterna a visibilidade pública do plano
export function toggleIsPublic(id) {
  return api.patch(`/plans/${id}/toggle-public`);
}
